module.exports = __webpack_public_path__ + "static/media/aluminio-rollo-blanco.461d5e5f.jpg";